// import styled from "styled-components";
// import { mobile } from "../responsive";
import './CategoryItem.css'
// const Container = styled.div`
//   flex: 1;
//   margin: 3px;
//   height: 70vh;
//   position: relative;
// `;

// const Image = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   border-radius: 2px; 
//   ${mobile({ height: "20vh" })}
// `;

// const Info = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
// `;

// const Title = styled.h1`
//     color:white;
//     margin-bottom: 20px;
// `;

// const Button = styled.button`
//     border:none;
//     padding: 10px;
//     background-color: white;
//     color:gray;
//     cursor: pointer;
//     font-weight: 600;
// `;

// const CategoryItem = ({ item }) => {
//   return (
//     <Container>
//       <Image src={item.img} />
//       <Info>
//         <Title>{item.title}</Title>
//         <Button>SHOP NOW</Button>
//       </Info>
//     </Container>
//   );
// };

// export default CategoryItem;

import React from 'react'
import { Link } from "react-router-dom";

const CategoryItem = ({item}) => {
  return (
    
          <div className="parent2">
      <div className="div5">
       <Link to="/products"> <img src={item.img} alt="" height="140px" width="100%"/></Link>
        <p>{item.title}</p>
      </div>
      </div>
    
  )
}

export default CategoryItem
